import React from "react";
import l from "components/util/l";

const EditSubmitComponent = ({ onDeleteNode }) =>
  <div className='w-100 d-flex justify-content-between'>
    <button type="submit" class="btn btn-primary font-weight-bold" style={{ width: "73%" }}>{l("Guardar%GA023")}</button>
    <button type="button" onClick={onDeleteNode} class="btn btn-outline-danger" style={{ width: "25%" }}>{l("Eliminar%GA001")}</button>
  </div>

export default EditSubmitComponent;